import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import { MatDialog } from '@angular/material';
import { NavItem } from '../../models/nav-item';

@Component({
  selector: 'app-menu-item',
  template: require('./menu-item.component.html')
})
export class MenuItemComponent implements OnInit {
  @Input() items: NavItem[];
  @ViewChild('childMenu') public childMenu;

  constructor(public router: Router, private dialog: MatDialog) {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/menu-item/menu-item.component.ts